namespace Matrix.Data {
    export interface AccountHoldingRow {
        HoldingId?: number;
        InstanceCode?: string;
        AccountCode?: string;
        AccountName?: string;
        SubAccountCode?: string;
        SecurityId?: number;
        SecurityCode?: string;
        SecurityName?: string;
        LongOrShort?: string;
        SourceCode?: string;
        AsAtDate?: string;
        LotCount?: number;
        TradeDate?: string;
        SettlementDate?: string;
        QtyFace?: number;
        QtyFaceOriginal?: number;
        LocalCurrencyCode?: string;
        PriceLocal?: number;
        PriceSource?: string;
        PriceUnderlyingLocal?: number;
        FxLocalToBase?: number;
        FxRateSource?: string;
        MarketValueLocal?: number;
        AccruedInterestLocal?: number;
        EffectiveExposureLocal?: number;
        CostLocal?: number;
        ProfitOrLossLocal?: number;
        PriceBase?: number;
        MarketValueBase?: number;
        AccruedInterestBase?: number;
        EffectiveExposureBase?: number;
        CostBase?: number;
        ProfitOrLossBase?: number;
        FxBaseToFirmCurrency?: number;
        TotalMarketValueBase?: number;
        TotalExposureBase?: number;
        MarketValueWeight?: number;
        ExposureWeight?: number;
        ModifiedDuration?: number;
        Yield?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace AccountHoldingRow {
        export const idProperty = 'HoldingId';
        export const nameProperty = 'InstanceCode';
        export const localTextPrefix = 'Data.AccountHolding';
        export const deletePermission = 'Read:AccountHolding';
        export const insertPermission = 'Read:AccountHolding';
        export const readPermission = 'Read:AccountHolding';
        export const updatePermission = 'Read:AccountHolding';

        export declare const enum Fields {
            HoldingId = "HoldingId",
            InstanceCode = "InstanceCode",
            AccountCode = "AccountCode",
            AccountName = "AccountName",
            SubAccountCode = "SubAccountCode",
            SecurityId = "SecurityId",
            SecurityCode = "SecurityCode",
            SecurityName = "SecurityName",
            LongOrShort = "LongOrShort",
            SourceCode = "SourceCode",
            AsAtDate = "AsAtDate",
            LotCount = "LotCount",
            TradeDate = "TradeDate",
            SettlementDate = "SettlementDate",
            QtyFace = "QtyFace",
            QtyFaceOriginal = "QtyFaceOriginal",
            LocalCurrencyCode = "LocalCurrencyCode",
            PriceLocal = "PriceLocal",
            PriceSource = "PriceSource",
            PriceUnderlyingLocal = "PriceUnderlyingLocal",
            FxLocalToBase = "FxLocalToBase",
            FxRateSource = "FxRateSource",
            MarketValueLocal = "MarketValueLocal",
            AccruedInterestLocal = "AccruedInterestLocal",
            EffectiveExposureLocal = "EffectiveExposureLocal",
            CostLocal = "CostLocal",
            ProfitOrLossLocal = "ProfitOrLossLocal",
            PriceBase = "PriceBase",
            MarketValueBase = "MarketValueBase",
            AccruedInterestBase = "AccruedInterestBase",
            EffectiveExposureBase = "EffectiveExposureBase",
            CostBase = "CostBase",
            ProfitOrLossBase = "ProfitOrLossBase",
            FxBaseToFirmCurrency = "FxBaseToFirmCurrency",
            TotalMarketValueBase = "TotalMarketValueBase",
            TotalExposureBase = "TotalExposureBase",
            MarketValueWeight = "MarketValueWeight",
            ExposureWeight = "ExposureWeight",
            ModifiedDuration = "ModifiedDuration",
            Yield = "Yield",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
